var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 3,
    viewBox: "0 0 11 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90742 1.29267C2.90742 0.545044 2.35006 0 1.58555 0C0.865421 0 0.263672 0.573984 0.263672 1.29267C0.263672 1.96794 0.865421 2.58534 1.58555 2.58534C2.28101 2.58534 2.90742 1.96794 2.90742 1.29267ZM6.69046 1.29267C6.69046 0.545044 6.1331 0 5.36859 0C4.64846 0 4.04671 0.573984 4.04671 1.29267C4.04671 1.96794 4.64846 2.58534 5.36859 2.58534C6.06405 2.58534 6.69046 1.96794 6.69046 1.29267ZM9.15209 0C9.91661 0 10.474 0.545044 10.474 1.29267C10.474 1.96794 9.84756 2.58534 9.15209 2.58534C8.43195 2.58534 7.8302 1.96794 7.8302 1.29267C7.8302 0.573984 8.43195 0 9.15209 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.ed8b197478bd0ee83f5f7c8172ea6eae.svg";
export { ForwardRef as ReactComponent };